import type { FiltersConfig } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import { filtersConfigStatusMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import type { OrderedSearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import createAdsSellersFilter from "../models/AdsSellersFilter/factory";
import createBusinessModelFilter from "../models/BusinessModelFilter/factory";
import createCategoryFilter from "../models/CategoryFilter/factory";
import createIabCategoriesFilter from "../models/IabCategoriesFilter/factory";
import createIosIdentifierFilter from "../models/IdentifiersFilter/iosFactory";
import createIosDownloadAndEngagementFilter from "../models/IosDownloadAndEngagementFilter/factory";
import createListedAddressFilter from "../models/ListedAddressFilter/factory";
import createPermissionsFilter from "../models/PermissionsFilter/factory";
import createPriceFilter from "../models/PriceFilter/factory";
import createRatingFilter from "../models/RatingFilter/factory";
import createReleaseDateFilter from "../models/ReleaseDateFilter/factory";
import createSdkFilter from "../models/SdkFilter/factory";
import createUpdateDateFilter from "../models/UpdateDateFilter/factory";
import { appOperatingSystemMap } from "../types/commonFiltersDto";
import type { IFindAppsDescriptionDto } from "../types/descriptionDto";

import { withFilterBaseProps } from "./utils";

const EMPTY_FILTERS_CONFIG: OrderedSearchFilterInstance[] = [];

export const createIosFilterConfig = (
    description?: IFindAppsDescriptionDto,
): FiltersConfig<OrderedSearchFilterInstance[]> => {
    if (!description) {
        return { filtersList: EMPTY_FILTERS_CONFIG, status: filtersConfigStatusMap.pending };
    }
    const platform = appOperatingSystemMap.ios;

    const withProps = withFilterBaseProps(platform);

    return {
        status: filtersConfigStatusMap.ready,
        filtersList: [
            withProps(createCategoryFilter(platform, description), 300),
            withProps(createIabCategoriesFilter(description), 310),
            withProps(createUpdateDateFilter(description), 320),
            withProps(createReleaseDateFilter(description), 325),
            withProps(createSdkFilter(description.sdksFilter, platform), 330),
            withProps(createAdsSellersFilter(description.iosAdsSellers), 340),
            withProps(createPermissionsFilter(description.iosPermission), 350),
            withProps(createListedAddressFilter(), 360),
            withProps(createIosDownloadAndEngagementFilter(description), 370),
            withProps(createRatingFilter(description.rating), 380),
            withProps(createBusinessModelFilter(description.appBusinessModels), 390),
            withProps(createPriceFilter(description), 400),
            withProps(createIosIdentifierFilter(description.iosIdentifiers), 410),
        ],
    };
};
